import { connect } from "react-redux";
import ChartWrapper from "./ChartWrapper";


const mapStateToProps = (state) => ({

    isTrendComparison: state.BenchmarkFilteringReducer.isTrendComparison

});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(ChartWrapper);
